export const BRAND_COLOR = '#3dcdc2';
export const ACCENT = '#33b0a6';
export const LIGHT_ACCENT = '#61d6cc';

// Secondary
export const SECONDARY_DISABLED = '#FFE8C7';
export const SECONDARY = '#FFD99C';
export const ICONS = '#CC6B54';

// Text
export const TITLE_COLOR = '#080f12';
export const SUB_TITLE_COLOR = '#595e61';
export const BODY_COLOR = '#404547';
export const DISABLED_TEXT = '#aeb0b0';
export const HEADER_TEXT = '#1e212a';

// Backgrounds
export const LAYOUT_BG_COLOR = '#ffffff';
export const NAV_BG_COLOR = '#24292e';
export const BORDER_HIGH_LIGHT = '#C7C9CC';
export const BORDER_COLOR = '#ADB0B0';

// ALERTS

// Success
export const SUCCESS = '#52BD40';
export const SUCCESS_ACCENT = '#f6ffec';

// Warning
export const WARNING = '#FFF212';
export const WARNING_ACCENT = '#faad14';

// Error
export const ERROR = '#D66361';
export const ERROR_ACCENT = '#fff2f0';

// Info
export const INFO = '#48a7dc';
export const INFO_ACCENT = '#e6f6ff';
export const PILL_1 = '#BD9963';

// Common
export const LIGHT_GRAY = '#757a7d';
export const BG_AVATAR = '#919496';
export const DIVIDER = '#707070';
export const NAV_COLOR = '#29918A';
export const NAV_BG = '#EBFAFA';
